const _devMode = ref(false)

export function useDevMode() {
  onMounted(() => {
    const route = useRoute()
    if (route.query.dev === 'true') {
      sessionStorage.setItem('dev_mode', '1')
    }
    _devMode.value = sessionStorage.getItem('dev_mode') === '1'
  })
  return { devMode: readonly(_devMode) }
}
